/**
 * @source @open-social-protocol/osp-api-index-types result-wrapper.ts (osp-client 1.2.x)
 */

export class IndexError extends Error {
  readonly code: string;
  readonly data: unknown;

  constructor(data?: unknown) {
    const code = "INDEX_ERROR";
    const msg = data ? `${code}: ${JSON.stringify(data)}` : code;
    super(msg);
    this.name = "IndexError";
    this.data = data;
    this.code = code;
  }
}

/** 业务错误体（`OspApiBaseResponse` 的 code / msg 部分） */
export interface ApiErrorBody {
  code?: number | string;
  msg?: string;
}

/**
 * 从任意请求异常里取出后端 `{ code, msg }`（EDG-552）。
 *
 * swagger 客户端非 2xx 时抛出的是 HttpResponse，错误体挂在 `.error` 上；经 `wrapperResult` 后是
 * `IndexError`，错误体在 `.data` 上。直接读 `err.code` 两种情况都拿不到 —— 14xxxx / 106040
 * 等错误码会静默落到通用文案。
 */
export function getApiErrorBody(error: unknown): ApiErrorBody {
  const raw =
    error instanceof IndexError
      ? error.data
      : ((error as { error?: unknown } | null)?.error ?? error);
  if (!raw || typeof raw !== "object") {
    return {};
  }
  const { code, msg } = raw as ApiErrorBody;
  return { code, msg };
}
